module.exports = __webpack_public_path__ + "img/d3ea002.jpg";